import dayjs from 'dayjs';

// Repo belum punya util tanggal bersama — tiap modul punya formatternya
// sendiri (lihat pages/Crude/PlanAndProcurement/formatters.js). Ikuti pola itu.

export const EMPTY_VALUE = '—';

// Nama bulan disediakan per bahasa. Sebelumnya hanya ada versi Indonesia dan
// dipakai untuk kedua bahasa, sehingga tampilan Inggris ikut menampilkan
// "Okt"/"Agu"/"Des".
const MONTHS = {
  id: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'Mei',
    'Jun',
    'Jul',
    'Agu',
    'Sep',
    'Okt',
    'Nov',
    'Des',
  ],
  en: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ],
};

const NUMBER_LOCALE = { id: 'id-ID', en: 'en-US' };

// Seluruh tanggal dan jam pengumuman ditampilkan dalam Waktu Indonesia Barat,
// tidak mengikuti zona perangkat pengunjung. Tanpa ini, pengunjung di WITA/WIT
// melihat pengumuman pukul 23:30 WIB bertanggal keesokan harinya sementara
// kolom jam tetap menulis "WIB" — dua kolom yang saling bertentangan.
//
// Memakai Intl bawaan, bukan plugin timezone dayjs: repo ini belum memuat
// plugin itu dan menambahkannya berarti impor baru.
const JAKARTA_TIME_ZONE = 'Asia/Jakarta';

const jakartaParts = value => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;

  return new Intl.DateTimeFormat('en-GB', {
    timeZone: JAKARTA_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
    .formatToParts(date)
    .reduce((acc, part) => {
      acc[part.type] = part.value;
      return acc;
    }, {});
};

/**
 * Format tanggal tampilan: `03 Sep 2026`, selalu dalam WIB.
 * Nilai kosong / tidak valid dikembalikan sebagai em dash, bukan "Invalid Date".
 */
export const formatDisplayDate = (value, language = 'id') => {
  if (!value) return EMPTY_VALUE;
  const parts = jakartaParts(value);
  if (!parts) return EMPTY_VALUE;
  const months = MONTHS[language] || MONTHS.id;
  return `${parts.day} ${months[Number(parts.month) - 1]} ${parts.year}`;
};

/** Format jam tampilan: `18:00 WIB`. Sumbernya kolom yang sama dengan tanggal. */
export const formatDisplayTime = value => {
  if (!value) return EMPTY_VALUE;
  const parts = jakartaParts(value);
  if (!parts) return EMPTY_VALUE;
  return `${parts.hour}:${parts.minute} WIB`;
};

/** Nilai teks apa pun; kosong/null jadi em dash. */
export const formatText = value => {
  if (value === null || value === undefined) return EMPTY_VALUE;
  const text = String(value).trim();
  return text === '' ? EMPTY_VALUE : text;
};

/** Format angka ringkas untuk kolom BID (D-20). */
export const formatCount = (value, language = 'id') => {
  const number = Number(value);
  if (!Number.isFinite(number)) return '0';
  return number.toLocaleString(NUMBER_LOCALE[language] || NUMBER_LOCALE.id);
};

/** Format ukuran file dari byte menjadi teks terbaca (mis. "412 KB"). */
export const formatFileSize = (bytes, language = 'id') => {
  const size = Number(bytes);
  if (!Number.isFinite(size) || size <= 0) return EMPTY_VALUE;
  const locale = NUMBER_LOCALE[language] || NUMBER_LOCALE.id;
  if (size < 1024 * 1024) {
    return `${Math.round(size / 1024).toLocaleString(locale)} KB`;
  }
  return `${(size / (1024 * 1024)).toLocaleString(locale, { maximumFractionDigits: 1 })} MB`;
};

/** Nilai `value` untuk <Input type="date"> — butuh format YYYY-MM-DD. */
export const toDateInputValue = value => {
  if (!value) return '';
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : '';
};
